import type { ConvertibleShift } from "@sidegigllc/api/client";

/** One seat is what a shift converts unless the business says otherwise. */
export const DEFAULT_SEATS = 1;

/** A shift and the seats it gives candidates. */
export type ShiftConversion = { gigId: number; seats: number };

/** Overfill can push confirmed past the seat count, and a listed shift always has a seat to give. */
export const openSeatsOf = (shift: Pick<ConvertibleShift, "allowed_confirmed_pros" | "confirmed_count">) =>
  Math.max(shift.allowed_confirmed_pros - shift.confirmed_count, 1);

/** Seats picked for a shift, held to what's open; a shift never picked from uses the default. */
export const seatsFor = (
  shift: Pick<ConvertibleShift, "gig_id" | "allowed_confirmed_pros" | "confirmed_count">,
  seatsByGig: Record<number, number>,
) => Math.min(Math.max(seatsByGig[shift.gig_id] ?? DEFAULT_SEATS, DEFAULT_SEATS), openSeatsOf(shift));

export const conversionsOf = (
  shifts: Array<ConvertibleShift>,
  seatsByGig: Record<number, number>,
): Array<ShiftConversion> => shifts.map((shift) => ({ gigId: shift.gig_id, seats: seatsFor(shift, seatsByGig) }));
